
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PerformanceImage } from '@/components/ui/performance-image';

interface NavbarLogoProps {
  isCompact?: boolean;
}

export const NavbarLogo: React.FC<NavbarLogoProps> = ({ isCompact = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      // Already on home page - just scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Navigate to home (scroll handled by global router)
      navigate('/');
    }
  };

  return (
    <Link 
      to="/" 
      onClick={handleLogoClick}
      className="flex items-center group"
      aria-label="Retour à l'accueil Maison Eridia"
    >
      <PerformanceImage 
        src="/lovable-uploads/maison-eridia-logo.png"
        alt="Maison Eridia"
        className={`
          object-contain transition-all duration-300 ease-out
          group-hover:opacity-80
          ${isCompact ? 'h-8 sm:h-9' : 'h-10 sm:h-12'}
        `}
        priority={true}
        quality={75}
        maxWidth={300}
      />
    </Link>
  );
};
